"use client"

import { useIdentityToken, usePrivy } from "@privy-io/react-auth"
import { reatomComponent } from "@reatom/react"
import { useLayoutEffect } from "react"
import { gachaIdentityTokens } from "./gacha-identity-token"

// Commit SDK identity before query effects run. Never fetch users/me on render.
export const GachaIdentityTokenProvider = reatomComponent(
  ({ children }: { children: React.ReactNode }) => {
    const { user, ready, authenticated } = usePrivy()
    const { identityToken } = useIdentityToken()
    useLayoutEffect(() => {
      gachaIdentityTokens.setSession(
        ready && authenticated && user
          ? {
              userId: user.id,
              identityToken,
              wallets: user.linkedAccounts.flatMap((account) => {
                if (
                  account.type === "wallet" &&
                  account.chainType === "ethereum"
                )
                  return [account.address]
                if (account.type === "cross_app")
                  return [...account.embeddedWallets, ...account.smartWallets]
                    .map((wallet) => wallet.address)
                    .filter((address) => /^0x[0-9a-fA-F]{40}$/.test(address))
                return []
              }),
            }
          : null,
      )
    })
    useLayoutEffect(() => () => gachaIdentityTokens.setSession(null), [])
    return children
  },
  "GachaIdentityTokenProvider",
)
